// extracted by mini-css-extract-plugin
export var container = "_im-0";
export var segment = "_im-2";
export var segmentActive = "_im-3";
export var track = "_im-1";